import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./my-account.m.css";
import { Link } from "@quintype/components";
import { setIsLogin } from "../../store/actions";
// import { googleLogout } from "@react-oauth/google";
import MyProfile from "./my-profile";
// import SavedArticles from "./saved-articles";
import { get } from "lodash";
import { googleLogout } from "@react-oauth/google";
import Close from "../other-icons/Close";
import DownArrow from "../other-icons/DownArrow";
import Signout from "../other-icons/Signout";
import { addLogoutToDataLayer } from "../../helper/datalayer-utils";

function MyAccount({ closeModal }) {
  const dispatch = useDispatch();
  const [isDropdownCollapsed, setIsDropdownCollapsed] = useState("myprofile");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  useEffect(() => {
    if (window) {
      const url = window.location.href.split("?")[0];
      setRedirectUrl(url);
    }
  }, []);

  useEffect(() => {
    if (userdetails?.userData?.id) {
      setIsLoading(false);
    }
  }, [userdetails?.userData?.id]);

  const onDropdownBtnHandler = (value) => {
    if (value === isDropdownCollapsed) {
      setIsDropdownCollapsed("");
    } else {
      setIsDropdownCollapsed(value);
    }
  };

  const logoutHandler = () => {
    addLogoutToDataLayer(window.location.href, userdetails);
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("access_token");
    window.localStorage.removeItem("refresh_token");
    localStorage.removeItem("commentsToken");
    window.location.search = "";
    localStorage.setItem("isProfileOpen", "false");
    googleLogout();
    dispatch(setIsLogin(false));
    window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${redirectUrl}`;
  };
  if (isLoading)
    return (
      <div styleName="loading-animation">
        <div styleName="loading-animation__circle"></div>
      </div>
    );

  return (
    <div styleName="my-account-wrapper">
      <div styleName="close-btn-wrapper" onClick={closeModal}>
        <Close color="black" width="12px" height="12px" />
      </div>
      {/* <p styleName="user-mail-id">{email}</p> */}
      <div styleName={`my-account-detail-container ${isDropdownCollapsed === "myprofile" ? "collapsed" : "close"}`}>
        <div
          styleName={`title ${isDropdownCollapsed === "myprofile" ? "title-bg" : ""}`}
          // onClick={() => onDropdownBtnHandler("myprofile")}
        >
          <span styleName="title-text">My Profile</span>
          {/* <div styleName="dropdown-svg-container">
            {isDropdownCollapsed === "myprofile" ? (
                            <DownArrow color="black" height="12px" width="12px" />

            ) : (
               <DownArrow color="black" height="12px" width="12px" />
            )}
          </div> */}
        </div>
        {isDropdownCollapsed === "myprofile" && <MyProfile />}
      </div>
      <Link href="/bookmark">
        <div onClick={closeModal} styleName={`${isDropdownCollapsed === "savedarticles" ? "collapsed" : "close"}`}>
          <div
            styleName={`title ${isDropdownCollapsed === "savedarticles" ? "title-bg" : ""}`}
            // onClick={() => onDropdownBtnHandler("savedarticles")}
          >
            <span styleName="title-text">Bookmark</span>
            <div styleName="dropdown-svg-container" className="rotate-right">
              {isDropdownCollapsed === "savedarticles" ? (
                <DownArrow color="black" height="12px" width="12px" />
              ) : (
                <DownArrow color="black" height="12px" width="12px" />
              )}
            </div>
          </div>
          {/* {isDropdownCollapsed === "savedarticles" && <SavedArticles savedStories={savedStories} />} */}
        </div>
      </Link>
      <button
        styleName="logout-btn"
        onClick={() => {
          logoutHandler();
        }}
      >
        {/* <Link href={}> */}
        <Signout color="#b82831" width="16px" height="16px" />
        Log Out
        {/* </Link> */}
      </button>
    </div>
  );
}

export default MyAccount;
